export default __webpack_public_path__ + "static/help_05_03_2-2d0b5b217c9ffc58a0a171ebebb112aa.png";